/**
 * 削除確認用メッセージを生成する
 *
 * @param label 表示したい対象名称 (HTML タグを含む場合は既にタグで囲まれた文字列を渡す)
 * @param isUsedDocument true: 利用中ダイアログ文言, false: 通常削除確認文言
 * @returns HTML 文字列 (dangerouslySetInnerHTML 用)
 */
export function buildDeleteMessage(label: string, isUsedDocument: boolean): string {
    if (isUsedDocument) {
        return `<strong>「${label}」</strong>を利用中のドキュメントが存在します。<br/>削除しますか？`;
    } else {
        return `<strong>「${label}」</strong>を削除しますか？`;
    }
}
